import React, { useEffect, useState } from "react";
import SelectFields from "./selectFields";
import TimezoneService from "../api/timezone";
import { useSelector } from "react-redux";

function timezoneOffsetToNumber(offset) {
  // Split into hours and minutes (e.g., "-05:30" → ["-05", "30"])
  const [hours, minutes] = offset.split(":");

  // Convert hours and minutes to numbers
  const hoursNum = parseInt(hours, 10);
  const minutesNum = parseInt(minutes, 10);

  // Calculate total offset in decimal (e.g., -5 + (-30/60) = -5.5)
  const decimalOffset = hoursNum + (minutesNum / 60) * Math.sign(hoursNum);

  return decimalOffset;
}

function TimezonePicker(props) {
  const [list, setList] = useState();
  const organziation = useSelector(({ organziation }) => organziation);

  function getTimezones() {
    const orgObj =
      organziation ?? JSON.parse(localStorage.getItem("defaultOrganization"));
    const apiKey = orgObj?.api_key_list?.[0]?.key;
    TimezoneService.GetTimezones(apiKey).then((response) => {
      if (response.success && response.count > 0) {
        setList(
          response.config_locale
            ?.filter((timezone) => timezone.timezone)
            .map((timezone) => ({
              id: timezone.timezone,
              value: timezoneOffsetToNumber(timezone.utc_offset_display),
              label: timezone.utc_offset_display + " " + timezone.timezone,
            }))
        );
      }
    });
  }
  useEffect(() => {
    getTimezones();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <SelectFields {...props} fields={list || []} />;
}

export default TimezonePicker;
